var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"interior-box"}},[_c('h3',{staticClass:"center"},[_vm._v("Besonderes")]),_c('br'),_c('image-gallery',{attrs:{"images":_vm.galleryImages}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }